import { IOffersDataState } from '../../types/offersData';
import { EComparisonStatus } from '../../repositories/newbuilding-search/entities/get_newbuildings_for_serp/NewbuildingForSerpItem';

export enum EOffersActions {
  set = 'set/regions',
  setNewbuildingComparisonStatus = 'set/newbuilding-comparison-status',
}

export interface ISetOffersDataAction {
  type: EOffersActions.set;
  data: IOffersDataState;
}

export interface ISetNewbuildingComparisonStatusAction {
  type: EOffersActions.setNewbuildingComparisonStatus;
  newbuildingId: number;
  comparisonStatus: EComparisonStatus;
}

export type INewbuildingsAction = ISetOffersDataAction | ISetNewbuildingComparisonStatusAction;

export function setOffersData(offersData: IOffersDataState) {
  return {
    data: offersData,
    type: EOffersActions.set,
  };
}

export function setNewbuildingComparisonStatus(newbuildingId: number, comparisonStatus: EComparisonStatus) {
  return {
    type: EOffersActions.setNewbuildingComparisonStatus,
    newbuildingId,
    comparisonStatus,
  };
}
